import { create } from "zustand";

/**
 * 경보 오버레이(AlarmCenter)가 지금 떠 있는가 — 119 승인 표면이 어디에 붙을지 정하는 단 하나의 신호.
 *   · 떠 있으면 승인 배너는 오버레이 **안**(맨 위)에 들어간다 — 겹침·z-index 싸움이 없다.
 *   · 닫혀 있으면 화면 아래 떠 있는 승인 바로 나온다.
 */
interface AlarmOverlayState {
  open: boolean;
  setOpen: (open: boolean) => void;
}
export const useAlarmOverlayStore = create<AlarmOverlayState>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
